<template>
  <a-tabs :activeKey="activeKey" tab-position="left" @tabClick="tabClick">
    <a-tab-pane :key="1" tab="进行中流程" style="margin-left: -24px">
      <admin-runtime-modal ref="AdminRuntimeModal"></admin-runtime-modal>
    </a-tab-pane>
    <a-tab-pane :key="2" tab="终了流程" style="margin-left: -24px">
      <admin-history-modal ref="AdminHistoryModal"></admin-history-modal>
    </a-tab-pane>
    <a-tab-pane :key="3" tab="非活性流程" style="margin-left: -24px">
      <admin-unactive-modal ref="AdminUnactiveModal"></admin-unactive-modal>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import AdminRuntimeModal from './modules/AdminRuntimeModal'
import AdminHistoryModal from './modules/AdminHistoryModal'
import AdminUnactiveModal from './modules/AdminUnactiveModal'

export default {
  name: 'ProcessInstanceManage',
  components: {
    AdminRuntimeModal,
    AdminHistoryModal,
    AdminUnactiveModal,
  },
  data() {
    return {
      description: '流程实例管理页面',
      // デフォルトで進行中案件を選ぶ
      activeKey: 1,
      // スタート条件
      startParam: {},
      // 検索条件
      queryParam: {},
      // テーブルタイトル
      columns: [],
      url: {},
    }
  },
  watch: {},
  mounted() {
    this.$refs.AdminRuntimeModal.parent = this
  },
  methods: {
    tabClick: function (e) {
      this.activeKey = e
    },
  },
}
</script>
<style lang="less" scoped>
.ant-tabs {
  :global(.ant-tabs-left-bar) {
    padding: 10px 0;
  }
}

// /deep/ .ant-table-row-cell-ellipsis {
//   white-space: unset;
// }
</style>
